import {
  SET_FIRST_AVAILABLE_TIME_SLOT,
  SET_FIRST_AVAILABLE_TIME_SLOT_TEAMS_ID
} from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(
  state = initialState.firstAvailableTimeSlot,
  { type, payload }
) {
  switch (type) {
    case SET_FIRST_AVAILABLE_TIME_SLOT:
      return { ...state, time: payload };
    case SET_FIRST_AVAILABLE_TIME_SLOT_TEAMS_ID:
      return { ...state, teamsId: payload };
    case RESET_APP_STATE:
      return initialState.firstAvailableTimeSlot;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/firstAvailableTimeSlot/reducer.js